import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Image from 'components/Image'
import { storage } from 'data/firebase'

//import placeholderImage from './images/placeholder.png'

export default class FirebaseImage extends React.Component {
  state = {
    //src: placeholderImage,
    src: null,
  }

  componentWillMount() {
    const { imageRef, thumbnail, thumbnailSize } = this.props

    console.log('imageRef', imageRef)

    if (!imageRef) {
      this.setState({ error: true })
      return
    }

    console.log('imageRef', imageRef)

    if (!thumbnail) this.getImageUrl()

    storage.ref(`${imageRef.replace('images', 'thumbs')}_${thumbnailSize}_thumb`).getDownloadURL().then((url) => {
      this.setState({ src: url })
    }).catch((error) => {
      this.getImageUrl()
    })
  }

  getImageUrl = () => {
    const { imageRef } = this.props

    storage.ref(imageRef).getDownloadURL().then((url) => {
      this.setState({ src: url })
    }).catch((error) => {
      console.log('error')
      this.setState({ error: true })
    })
  }

  render() {
    const { className, imageRef, thumbnail, thumbnailSize, ...others } = this.props
    const { error, src } = this.state

    if (error || !src) return null

    return (
      <Image {...others} src={src} className={classNames('FirebaseImage', className)} />
    )
  }
}

FirebaseImage.propTypes = {
  className: PropTypes.string,
  imageRef: PropTypes.string,
  thumbnail: PropTypes.bool,
  thumbnailSize: PropTypes.oneOf(['64', '256', '512']),
}

FirebaseImage.defaultProps = {
  thumbnailSize: '256',
}


// WEBPACK FOOTER //
// ./src/components/FirebaseImage/FirebaseImage.js